/**
 * Setting up Gamification Settings
 */

const header_success_message = document.querySelector(
  ".holiday-gift-gamification .gamification-data .header_success_message"
).innerHTML;
const header_before_shipping_message = document.querySelector(
  ".holiday-gift-gamification .gamification-data .header_before_shipping_message"
).innerHTML;
const header_after_shipping_message = document.querySelector(
  ".holiday-gift-gamification .gamification-data .header_after_shipping_message"
).innerHTML;
const header_empty_message = document.querySelector(
  ".holiday-gift-gamification .gamification-data .header_empty_message"
).innerHTML;

const cart_success_message = document.querySelector(
  ".holiday-gift-gamification .gamification-data .cart_success_message"
).innerHTML;
const cart_before_shipping_message = document.querySelector(
  ".holiday-gift-gamification .gamification-data .cart_before_shipping_message"
).innerHTML;
const cart_after_shipping_message = document.querySelector(
  ".holiday-gift-gamification .gamification-data .cart_after_shipping_message"
).innerHTML;
const cart_empty_message = document.querySelector(
  ".holiday-gift-gamification .gamification-data .cart_empty_message"
).innerHTML;

const goal_price = Number(
  document.querySelector(
    ".holiday-gift-gamification .gamification-data .goal_price"
  ).textContent
);

const product_tag = document.querySelector(
  ".holiday-gift-gamification .gamification-data .product_tag"
).textContent;

const cart_promo_text = document.querySelector(
  ".holiday-gift-gamification .gamification-data .cart_promo_text"
).innerHTML;


window.holidayGamification = {
  header_empty_message,
  header_success_message,
  header_before_shipping_message,
  header_after_shipping_message,
  cart_empty_message,
  cart_success_message,
  cart_before_shipping_message,
  cart_after_shipping_message,
  product_tag,
  lastGoal: goal_price * 100,
  circleProgress: new ProgressBar.Circle(
    ".holiday-gift-gamification .progress-fill",
    {
      strokeWidth: 11,
      easing: "easeInOut",
      duration: 1400,
      color: "#F7F176",
      trailColor: "#fff",
      trailWidth: 1,
      svgStyle: null,
    }
  ),
  setProgress: function (cart) {
    let currentFinalPrice = 0;
    const totalCartPrice = cart.total_price;
    currentFinalPrice = 0;
    cart.items.forEach((item) => {
      if (item.properties["_holiday_gift"]) {
        currentFinalPrice += item.final_line_price;
      }
    });
    let progress = 0;
    if (totalCartPrice < window.settings.freeShipping) {
      progress = ((totalCartPrice / this.lastGoal) * 100).toFixed(2);
    } else {
      progress = (
        (Math.min(
          Math.max(currentFinalPrice, window.settings.freeShipping),
          this.lastGoal
        ) /
          this.lastGoal) *
        100
      ).toFixed(2);
    }

    const missingMoney = this.lastGoal - currentFinalPrice;

    const headerGamificationMessage = document.querySelectorAll(
      ".holiday-gift-gamification .gamification-message"
    );
    const progressIndicator = document.querySelectorAll(
      ".holiday-gift-gamification .progress-indicator"
    );
    const goalIcon = document.querySelectorAll(
      ".holiday-gift-gamification .goal-icon"
    );
    const shippingIcon = document.querySelectorAll(
      ".holiday-gift-gamification .free-shipping-icon"
    );

    shippingIcon.forEach((item) => {
      if (totalCartPrice < window.settings.freeShipping) {
        item.querySelector(".empty").classList.remove("hide");
        item.querySelector(".full").classList.add("hide");
      } else {
        item.querySelector(".full").classList.remove("hide");
        item.querySelector(".empty").classList.add("hide");
      }
    });

    goalIcon.forEach((item) => {
      if (currentFinalPrice >= this.lastGoal) {
        item.querySelector(".empty").classList.add("hide");
        item.querySelector(".full").classList.remove("hide");
      } else {
        item.querySelector(".full").classList.add("hide");
        item.querySelector(".empty").classList.remove("hide");
      }
    });

    progressIndicator.forEach((element) => {
      element.style.width = progress + "%";
    });
    this.circleProgress.animate((progress / 100).toFixed(1));

    const cartGamificationMessage = document.querySelectorAll(
      ".holiday-gift-gamification .cart-gamification-message"
    );

    let headerMessage = "";
    let cartMessage = "";

    if (totalCartPrice === 0) {
      headerMessage = header_empty_message;
      cartMessage = cart_empty_message;
    } else {
      const missingMoneyForShipping = Math.max(0, window.settings.freeShipping - totalCartPrice);
      headerMessage = header_before_shipping_message.replace(
        "$XX",
        formatPrice(missingMoneyForShipping / 100)
      );
      cartMessage = cart_before_shipping_message.replace(
        "$XX",
        formatPrice(missingMoneyForShipping / 100)
      );

      if (totalCartPrice >= window.settings.freeShipping) {
        const missingToGoal = Math.max(0, this.lastGoal - currentFinalPrice);
      
        headerMessage = header_after_shipping_message.replace(
          "$XX",
          formatPrice(missingToGoal / 100)
        );
        cartMessage = cart_after_shipping_message.replace(
          "$XX",
          formatPrice(missingToGoal / 100)
        );
      }
    }

    if (currentFinalPrice >= this.lastGoal) {
      headerMessage = header_success_message;
      cartMessage = cart_success_message;
    } 

    headerGamificationMessage.forEach((element) => {
      element.innerHTML = headerMessage;
    });
    cartGamificationMessage.forEach((element) => {
      element.innerHTML = cartMessage;
    });
  },
};

/**
 * Gamification Global
 * With are gonna create custom triggers for the cart Object
 * And also we would use Shopify/cart package to handle the cart operations
 */
// window.addEventListener("load", async (e) => {
document.addEventListener("calpak:cart-loaded", async() => {
  const cartState = await calpak.cart.getState();
  holidayGamification.setProgress(cartState);
});

/**
 * Take care of updates and changes of cart
 */
document.addEventListener("theme:cart:updated", (e) => {
  const cart = JSON.parse(calpak.stripHTML(e.detail.cart.sections["cart-json"]));
  holidayGamification.setProgress(cart);
});

document.addEventListener("DOMContentLoaded", () => {
  (function () {
    const cartHeader = document.querySelector(".cart__header");
    cartHeader.querySelector(".cart__free-shipping").style.display = "none";

    const cartHolidayGiftText = document.createElement("div");
    cartHolidayGiftText.classList.add("holiday-gift-header");
    cartHolidayGiftText.innerHTML = cart_promo_text;
    cartHeader.appendChild(cartHolidayGiftText);

    const cartHolidayGiftGamification = document.createElement("div");
    cartHolidayGiftGamification.classList.add("holiday-gift-gamification");
    cartHolidayGiftGamification.style.padding = "20px";
    if(window.settings.freeShipping < 200){
      cartHolidayGiftGamification.style.paddingLeft = "30px";
      cartHolidayGiftGamification.style.paddingRight = "30px";
    }

    const cartHolidayGiftMessage = document.createElement("div");
    cartHolidayGiftMessage.classList.add("cart-gamification-message");
    cartHolidayGiftGamification.appendChild(cartHolidayGiftMessage);

    const cartHolidayGiftGamificationProgressBar =
        document.createElement("div");
    cartHolidayGiftGamificationProgressBar.classList.add("progress-bar");
    cartHolidayGiftGamificationProgressBar.innerHTML = document.querySelector(
        ".holiday-gift-gamification .progress-bar.desktop"
    ).innerHTML;

    cartHolidayGiftGamification.appendChild(
        cartHolidayGiftGamificationProgressBar
    );

    cartHeader.appendChild(cartHolidayGiftGamification);
  })();
});